import { Chip, Divider, Grid, Typography } from "@mui/material";
import type { FilaInventario } from "../types/inventario.types";

interface CampoDetalle {
    etiqueta: string;
    valor: string;
}

interface InventarioDetalleContenidoProps {
    fila: FilaInventario;
}

const Campo = ({ etiqueta, valor }: CampoDetalle): JSX.Element => (
    <Grid item xs={6}>
        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", fontSize: 10.5 }}>
            {etiqueta}
        </Typography>
        <Typography variant="body2" sx={{ color: "#0f172a", fontWeight: 500 }}>
            {valor || "—"}
        </Typography>
    </Grid>
);

export const InventarioDetalleContenido = ({ fila }: InventarioDetalleContenidoProps): JSX.Element => {
    const colorEstatus = fila.activo ? "#15803D" : "#DC2626";

    return (
        <Grid container spacing={2} style={{ textAlign: "left" }}>
            <Grid item xs={12}>
                <Chip
                    label={fila.estatus}
                    size="small"
                    sx={{
                        color: colorEstatus,
                        backgroundColor: `${colorEstatus}1A`,
                        fontWeight: 700,
                        border: `1px solid ${colorEstatus}`,
                    }}
                />
            </Grid>

            <Campo etiqueta="Clave" valor={fila.clave} />
            <Campo etiqueta="Nombre" valor={fila.nombre} />
            <Campo etiqueta="Tipo de producto" valor={fila.tipoProducto} />
            <Campo etiqueta="Categoría" valor={fila.categoria} />
            <Campo etiqueta="Unidad de medida" valor={fila.unidadMedida} />
            <Campo etiqueta="Ubicación" valor={fila.ubicacion} />
            <Campo etiqueta="Almacén" valor={fila.almacen} />
            <Campo
                etiqueta="Precio"
                valor={fila.precio.toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
            />

            <Grid item xs={12}>
                <Divider />
            </Grid>

            <Campo etiqueta="Cantidad" valor={String(fila.cantidad)} />
            <Campo etiqueta="Mínimos" valor={String(fila.minimos)} />
            <Campo etiqueta="Máximos" valor={String(fila.maximos)} />
            <Campo etiqueta="Punto de reorden" valor={String(fila.puntoReorden)} />

            {fila.fechaCreacion && (
                <>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Campo etiqueta="Fecha de creación" valor={fila.fechaCreacion} />
                </>
            )}
        </Grid>
    );
};